<div class="modal">
  <div class="card">
    <div class="card-header">
      <h3 class="card-title">Podesi minimalnu količinu za materijal</h3>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <input type="text" 
                   mask="separator.2"
                   thousandSeparator="."
                   decimalMarker=","
                   class="form-control" 
                   [(ngModel)]="minimumMaterialQuantity" 
                   [ngModelOptions]="{standalone: true}" 
                   placeholder="Unesi minimalnu količinu" />
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer text-end">
      <button class="btn btn-secondary btn-question me-2" (click)="emitFalse()">Nazad</button>
      <button class="btn btn-success btn-question" (click)="emitTrue()" [disabled]="!minimumMaterialQuantity && minimumMaterialQuantity !== 0">Sačuvaj</button>
    </div>
  </div>
</div>